var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"commissionSettings"},[_c('Setting',{staticClass:"Setting"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }